import { API_BASE_URL, SUPPORT_EMAIL, SUPPORT_PHONE } from "../../config";
import CallToAction from "../cta/CallToAction";
import useAppData from "../../hooks/useAppData";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import NewsLetter from "../Newsletter";

const Footer = () => {
	const currentYear = new Date().getFullYear();
	const { settings, categories } = useAppData();

	return (
		<footer>
			<div style={{ backgroundColor: "#007db3" }}>
				<CallToAction />
			</div>

			<Container className="py-5 footer_main">
				<Row className="gx-4">
					<Col lg={3} md={6} sm={12} xs={12} className="mb-4 footer_main_logo">
						<Row className="py-1">
							<img
								className="logo-dark pb-3"
								src={
									settings?.logo_header && API_BASE_URL + settings.logo_footer
								}
								alt={settings?.website_title || "LOGO"}
							/>
							<h5>Stay Connected</h5>
							<p>
								Subscribe to get latest news, offers and logistic insight -
								straigh to your inbox
							</p>
							<NewsLetter />
						</Row>
					</Col>
					<Col lg={5} md={6} sm={12} xs={12} className="mb-4 footer_main_links">
						<h5 className="mb-5">Our Services</h5>
						<Row>
							<Col md={6} sm={6} xs={6}>
								<ul>
									{categories
										?.slice(0, Math.ceil((categories.length + 2) / 2))
										.map((category) => (
											<li key={category.id}>
												<a href={`/services/${category.slug}`}>
													{category.title}
												</a>
											</li>
										))}
								</ul>
							</Col>
							<Col md={6} sm={6} xs={6}>
								<ul>
									{categories
										?.slice(Math.ceil((categories.length + 2) / 2))
										.map((category) => (
											<li key={category.id}>
												<Link to={`/services/${category.slug}`}>
													{category.title}
												</Link>
											</li>
										))}
									<li>
										<Link
											to={"/privacy-policy"}
											onClick={() =>
												window.scrollTo({ top: 0, behavior: "smooth" })
											}
										>
											Privacy Policy
										</Link>
									</li>
									<li>
										<Link
											to={"/terms-condition"}
											onClick={() =>
												window.scrollTo({ top: 0, behavior: "smooth" })
											}
										>
											Terms & Conditions
										</Link>
									</li>
								</ul>
							</Col>
						</Row>
					</Col>
					<Col lg={4} md={6} sm={12} xs={12} className="mb-4 footer_main_links">
						<h5 className="mb-5">Useful Links</h5>
						<ul>
							<li>
								<Link
									to={"/about-us"}
									onClick={() =>
										window.scrollTo({ top: 0, behavior: "smooth" })
									}
								>
									About us
								</Link>
							</li>
							<li>
								<Link
									to={"/contact-us"}
									onClick={() =>
										window.scrollTo({ top: 0, behavior: "smooth" })
									}
								>
									Contact us
								</Link>
							</li>
							<li>Email Address: {settings?.email || SUPPORT_EMAIL}</li>
							<li>Phone number: {settings?.phone_number || SUPPORT_PHONE}</li>
							<li>Saturday - Friday 10:00 am - 8:00 pm</li>
						</ul>
					</Col>
				</Row>
			</Container>
			<hr />
			<Container className="pb-3">
				<Row>
					<small className="text-center">
						&copy; {currentYear} BlueDart Express Dubai. All rights reserved.
					</small>
				</Row>
			</Container>
		</footer>
	);
};

export default Footer;
